module.exports = __webpack_public_path__ + "img/miniLogo.28695b36.png";